import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FindLoad } from 'utils';
import { Loader } from 'components';
import { systemActions } from 'store';
import { OfficeAlly } from './officeAlly';
import { Stripe } from './stripe';
import { Availity } from './availity';
import { Therapy } from './therapy';
import { Zoom } from './zoom';
import { GoogleMeet } from './googleMeet';

const ACTION_TYPE = 'GET_SYSTEM_INTEGRATIONS';
export const Calendars = () => {
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        dispatch(systemActions.getIntegrations());
        dispatch(systemActions.getTelehealthStatus());
    }, []);

    if (loader?.length) {
        return <Loader />;
    }

    return (
        <div>
            <div className="integration-type-wrapper">
                <div className="integration-type-header">
                    <p>Clearinghouse Integrations</p>
                </div>
                <div className="integration-type-body">
                    <OfficeAlly />
                    <Availity />
                    <Therapy />
                </div>
            </div>

            <div className="integration-type-wrapper">
                <div className="integration-type-header">
                    <p>Payment Integrations</p>
                </div>
                <div className="integration-type-body">
                    <Stripe />
                </div>
            </div>

            <div className="integration-type-wrapper">
                <div className="integration-type-header">
                    <p>Telehealth Integrations</p>
                </div>
                <div className="integration-type-body">
                    <Zoom />
                    <GoogleMeet />
                </div>
            </div>
        </div>
    );
};
